import React from 'react';
import { Clear } from '@material-ui/icons';
import {
  Theme,
  makeStyles,
  createStyles,
  IconButton,
  IconButtonProps,
} from '@material-ui/core';
import { HoverBackground, NonHoverBorder } from '../../theme/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'absolute',
      zIndex: 10,
      right: theme.spacing(0.5),
      top: theme.spacing(0.5),
      backgroundColor: HoverBackground,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(0.75),
      '&:hover': {
        backgroundColor: NonHoverBorder,
      },
    },
  }),
);
export const CloseButton: React.FC<IconButtonProps> = props => {
  const classes = useStyles();

  return (
    <IconButton className={classes.root} {...props}>
      <Clear style={{ fontSize: 16 }} />
    </IconButton>
  );
};
